import type React from 'react';

import { Button, Image, Text } from '@change/ds-core-ui';
import { ArrowRightIcon, CheckCircleOutlineIcon, InstagramStickerIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import stickerLinkImage from '#src/assets/share/sticker_link.png';

const INSTAGRAM_URL = 'instagram://story-camera';

type Props = {
	onContinue: () => void;
};

export const EducationModalBody: React.FC<Props> = ({ onContinue }) => {
	const { translate } = useI18n();

	return (
		<div className="mt-4 flex flex-col" aria-label={translate('fe.components.psf.instagram.modal_name')}>
			<div className="flex flex-col gap-6 py-6">
				<div className="flex flex-col gap-6">
					<div className="flex items-center justify-center gap-3">
						<InstagramStickerIcon size="x-large" />
						<ArrowRightIcon />
						<div>
							<Image src={stickerLinkImage} alt={translate('corgi.psf.share.modals.body.sticker_link_image_alt')} />
						</div>
					</div>

					<Text as="p" size="x-small" fontWeight="bold" variant="heading" className="px-10 text-center">
						<Translate value="corgi.psf.share.modals.body.description" />
					</Text>
				</div>
				<div className="flex flex-col gap-4">
					<div className="border-stroke-success-weak bg-fill-success-weaker mb-4 flex items-center justify-center gap-3 rounded-md border p-6">
						<CheckCircleOutlineIcon />
						<Text size="large" className="text-typography-success font-semibold">
							<Translate value="corgi.psf.share.modals.body.link_copied_confirmation" />
						</Text>
					</div>
				</div>
			</div>
			<div className="border-stroke-weaker border-t py-4 pb-0">
				<Button
					as="a"
					href={INSTAGRAM_URL}
					target="_blank"
					variant="primary"
					onClick={onContinue}
					data-testid="instagram-share-continue"
					data-qa="instagram-share-continue"
					className="w-full"
				>
					<Translate value="corgi.psf.share.modals.body.button" />
				</Button>
			</div>
		</div>
	);
};
